import { connect } from "react-redux";
import WithTargetedContent from "./WithTargetedContent";
import {
  requestTargetedContent,
  getGlobalBannerContent,
  getContentTargetingStatus
} from "../../state/modules/contentTargeting";
import {
  getIsPremier,
  getIsRecognised,
  isLoggedIn,
  getIdentityHasResponded
} from "../../state/modules/user";
import {
  getStoreCode,
  getDefaultLanguage,
  getCountryCode,
  getKeyStoreDataversion
} from "../../state/modules/regionalStore";

const mapStateToProps = state => {
  return {
    content: getGlobalBannerContent(state),
    country: getCountryCode(state),
    store: getStoreCode(state),
    lang: getDefaultLanguage(state),
    keystoredataversion: getKeyStoreDataversion(state),
    premier: getIsPremier(state),
    isRecognised: getIsRecognised(state),
    isLoggedIn: isLoggedIn(state),
    identityHasResponded: getIdentityHasResponded(state),
    contentTargetingStatus: getContentTargetingStatus(state)
  };
};

const mapDispatchToProps = {
  requestTargetedContent
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithTargetedContent);
